import { render, staticRenderFns } from "./GrantAgreement.vue?vue&type=template&id=0e803bac&scoped=true&"
import script from "./GrantAgreement.vue?vue&type=script&lang=js&"
export * from "./GrantAgreement.vue?vue&type=script&lang=js&"
import style0 from "./GrantAgreement.vue?vue&type=style&index=0&id=0e803bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e803bac",
  null
  
)

export default component.exports